/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Color_Role_DangerInputs */

const en_enum_color_role_danger = /** @type {(inputs: Enum_Color_Role_DangerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Danger`)
};

const de_enum_color_role_danger = /** @type {(inputs: Enum_Color_Role_DangerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Danger`)
};

/**
* | output |
* | --- |
* | "Role Danger" |
*
* @param {Enum_Color_Role_DangerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_color_role_danger = /** @type {((inputs?: Enum_Color_Role_DangerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Color_Role_DangerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_color_role_danger(inputs)
	return de_enum_color_role_danger(inputs)
});